export const toggleSwitchConfig = () => {
  return {
    colorScheme: {
      light: {
        background: 'var(--form-element-background)',
        hoverBackground: 'var(--form-element-background)',
        // checkedBackground: '{green.500}',
        // checkedHoverBackground: '{green.500}',

        borderColor: '{formField.borderColor}',
        hoverBorderColor: '{formField.hoverBorderColor}',
        checkedBorderColor: 'transparent',

        handleBackground: 'var(--primary-600)',
        handleHoverBackground: 'var(--primary-700)'
      },

      dark: {
        background: 'var(--form-element-background)',
        hoverBackground: 'var(--form-element-background)',
        handleBackground: 'var(--primary-200)'
        // checkedBackground: '{green.500}',
        // checkedHoverBackground: '{green.500}',
      }
    }
  }
}
